export const ConfigurationUpdate = ({id, dataTarget, title, handleHeaderAction, headerButtonText, ariaLabel, isActionAllowed, children}) => {
	return (
		<div className="card mb-3">
			<div className="card-header">
				<div className="row align-items-center justify-content-between">
					<div className="col-3">
						<h5 className="mb-0">
							<button
								className="button-card-header button-no-style collapsed"
								id={id}
								type="button"
								data-toggle="collapse"
								data-target={`#${dataTarget}`}
								aria-expanded="true"
								aria-controls={dataTarget}>
								{title} <i className="fas fa-chevron-down"></i>
							</button>
						</h5>
					</div>
					{
						handleHeaderAction && isActionAllowed && 
						<div className="col-auto">
							<button
								type="button"
								className="btn btn-success btn-sm ml-2"
								onClick={ () => handleHeaderAction() }>
								<i className="fas fa-plus"></i> { headerButtonText }
							</button>
						</div>
					}
				</div>
			</div>

			<div
				className="card-body bg-light border-top details-container collapse"
				id={dataTarget}
				aria-labelledby={ariaLabel}
				data-parent={`#${id}`}>
				{children}
			</div>
		</div>
	);
};
